import type { JSX } from 'react';
import { ArrowLeft, Mail, Copy, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCertificateLink } from '../hooks/useCertificateLink';
import { CandidateStatusBadge } from './CandidateStatusBadge';
import type { Candidate } from '../types/candidate.types';

interface CandidateDetailHeaderProps {
  candidate: Candidate;
  onBack: () => void;
}

export function CandidateDetailHeader({
  candidate,
  onBack,
}: CandidateDetailHeaderProps): JSX.Element {
  const { copyCertificateLink, openCertificate } = useCertificateLink();

  return (
    <div className="flex flex-wrap items-center gap-4">
      <Button variant="ghost" size="icon" onClick={onBack} aria-label="Back">
        <ArrowLeft className="h-4 w-4" />
      </Button>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold">{candidate.name}</h1>
          <CandidateStatusBadge status={candidate.status} />
        </div>
        <div className="flex items-center gap-1 text-muted-foreground">
          <Mail className="h-4 w-4" />
          <span>{candidate.email}</span>
        </div>
      </div>
      <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
        <Button variant="outline" size="sm" onClick={() => copyCertificateLink(candidate.shareId)}>
          <Copy className="mr-2 h-4 w-4" />
          Copy Certificate Link
        </Button>
        <Button variant="outline" size="sm" onClick={() => openCertificate(candidate.shareId)}>
          <ExternalLink className="mr-2 h-4 w-4" />
          Open Certificate
        </Button>
      </div>
    </div>
  );
}
